import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { optionLabel } from "../utils/optionLabel";
import { gradeOptionsQuery } from "./gradeOptionsQuery";

export interface GradeFilterOption {
  value: string;
  label: string;
  key: string;
}

export const useGradeOptions = ({ enabled }: { enabled: boolean }) => {
  const grades = useQuery({ ...gradeOptionsQuery, enabled });
  const options = useMemo<GradeFilterOption[]>(
    () =>
      (grades.data ?? []).map((grade) => ({
        value: grade.gradeCode,
        label: optionLabel(grade.gradeCode, grade.description),
        key: grade.gradeCode,
      })),
    [grades.data],
  );

  return { options, isLoading: grades.isLoading, isError: grades.isError };
};
